import { SURVEY } from "../constants/modules-id";
import { RestrictionFactory } from "../utils/restriction-factory";

const { ModuleOr404 } = RestrictionFactory(SURVEY);

export const SurveyModuleOr404 = ModuleOr404;
